import Request, { SimpleResponse } from './Request';

export interface IGroup {
    id: number;
    name: string;
    fixedApprover: string;
    code: string;
    active: boolean;
    featured: boolean;
    parent: IGroup;
    children: IGroup[];
    latitude: number;
    longitude: number;
    order: number;
}

class Group {
    static GetAll = (): IGroup[] => { return Request.DoGet('group/all') as unknown as IGroup[]; };
    static Get = (id: Number): IGroup => { return Request.DoGet('group/' + id) as unknown as IGroup; };
    static Update = (id: Number, data: IGroup): SimpleResponse => { return Request.DoPut('group/' + id, data) as unknown as SimpleResponse; };
    static Create = (data: IGroup): SimpleResponse => { return Request.DoPost('group', data) as unknown as SimpleResponse; };
    static Delete = (id:Number): SimpleResponse => { return Request.DoDelete('group/' + id) as unknown as SimpleResponse; };
}

export default Group;